import { render, staticRenderFns } from "./Sidenav.vue?vue&type=template&id=5cfe5fe8"
import script from "./Sidenav.vue?vue&type=script&lang=js"
export * from "./Sidenav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports